import React from "react";
import "./ui.css";
import useCountUp from "../../hooks/useCountUp";

// One KPI-card shape for every role's stat strip (My Tickets, Pending,
// In Progress, Completed, ...). `tone` picks the icon's accent color from
// the shared semantic palette -- it does not change what the number means,
// only how it's colored.
export default function StatCard({ icon, label, value, tone = "primary", loading = false }) {
  const displayValue = useCountUp(value);
  return (
    <div className="ui-statcard">
      <div className={`ui-statcard-icon ui-statcard-icon-${tone}`}>{icon}</div>
      <div className="ui-statcard-body">
        <span className="ui-statcard-label">{label}</span>
        <strong className="ui-statcard-value">{loading ? "…" : displayValue}</strong>
      </div>
    </div>
  );
}

export function StatCardGrid({ children }) {
  return <div className="ui-statcard-grid">{children}</div>;
}
